import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const FAQ_ITEMS = [
  { q: 'faq.q1', a: 'faq.a1' },
  { q: 'faq.q2', a: 'faq.a2' },
  { q: 'faq.q3', a: 'faq.a3' },
  { q: 'faq.q4', a: 'faq.a4' },
  { q: 'faq.q5', a: 'faq.a5' },
];

export default function Faq() {
  const { t } = useTranslation();
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-background-100">
      <div className="mx-auto max-w-3xl px-4 md:px-6 py-14 md:py-20">
        <h2 className="font-heading font-bold text-foreground-950 text-2xl md:text-4xl text-center mb-10">
          {t('faq.title')}
        </h2>

        <div className="space-y-3">
          {FAQ_ITEMS.map((item, idx) => {
            const isOpen = open === idx;
            return (
              <div
                key={item.q}
                className="bg-background-50 border border-background-200 rounded-lg overflow-hidden"
              >
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? null : idx)}
                  className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
                >
                  <span className="font-heading font-semibold text-foreground-900 text-sm md:text-base">
                    {t(item.q)}
                  </span>
                  <span
                    className={`flex items-center justify-center w-6 h-6 text-foreground-500 transition-transform ${
                      isOpen ? 'rotate-180' : ''
                    }`}
                  >
                    <i className="ri-arrow-down-s-line text-lg" />
                  </span>
                </button>
                {isOpen && (
                  <div className="px-5 pb-5 text-foreground-600 text-sm md:text-base leading-relaxed">
                    {t(item.a)}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}